import api from "@/shared/api/base-api";
import { ILoginDTO } from "../model/types";

export const loginApi = {
  checkUser: (data: ILoginDTO) => api.post("/v1/customers/phone", data),

  loginUser: (data: ILoginDTO) =>
    api.post("/v2/aggregator-shipper/client", data),

  loginWithoutOTP: (data: ILoginDTO) =>
    api.post("/v2/customers/login-without-otp", data),
};
